import { render, staticRenderFns } from "./MultiSnackbar.vue?vue&type=template&id=ec4d04a4"
import script from "./MultiSnackbar.vue?vue&type=script&lang=js"
export * from "./MultiSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports